import {
  CreateEmployeeCandidateRequestInput as GqlCreateEmployeeCandidateRequestInput,
  EmployeeCandidateHiringStatus,
  EmployeeCandidateRequest as GqlEmployeeCandidateRequest,
  EmployeeCandidateResultCategory,
  GetEmployeeCandidateListQuery,
} from "../graphql/generated.ts";
import { toHumanReadable } from "../utils/string.ts";

export type EmployeeCandidateRequest =
  GetEmployeeCandidateListQuery["employeeCandidateRequests"]["data"][0];

export type RawEmployeeCandidateRequest = Omit<
  GqlEmployeeCandidateRequest,
  "id" | "createdAt"
>;
export type EmployeeCandidateRequestInput =
  GqlCreateEmployeeCandidateRequestInput;

export const candidateResultCategoryOptions = Object.values(
  EmployeeCandidateResultCategory
).map((item) => ({
  value: item,
  label: toHumanReadable(item),
}));

export const candidateHiringStatusOptions = Object.values(
  EmployeeCandidateHiringStatus
).map((item) => ({
  value: item,
  label: toHumanReadable(item),
}));
